import React from "react";
import { Button, Table, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function DistrictMeeting({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered>
          <thead>
            <tr className="table-secondary text-center align-middle">
              <th style={{ width: "40%" }}>Name of the Meeting</th>
              <th style={{ width: "10%" }}>Date of Meeting (dd/mm/yyyy)</th>
              <th style={{ width: "10%" }}>Total Number of Meetings</th>
              <th style={{ width: "10%" }}>Number of Persons Attended</th>
              <th style={{ width: "10%" }}>Participants Attended (Designation)</th>
              <th style={{ width: "10%" }}>Status on Last Meeting Key Decisions</th>
              <th style={{ width: "10%" }}>Key Decisions of the Current Meeting, if Any</th>
            </tr>
          </thead>

          <tbody>
            {/* Row 1 - District Level Meetings */}
            <tr>
              <td className="align-top" style={{ whiteSpace: "pre-line" }}>
                <b>1. District level meeting with following agenda:</b>
                {"\n"}1.1. Program review meeting with NACP facilities
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number" className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* sec 2  */}
            <tr>
              <td className="align-top">
                1.2. HIV/TB coordination meeting with NACP facilities
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number" className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* sec3 */}
            <tr>
              <td className="align-top">
                1.3. Meeting between ART center and CSC for LFU tracking
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* sec 4 */}
            <tr>
              <td className="align-top">
                1.4. Coordination meeting with NHM at district level
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* Row 2 - DAPCC Meeting */}
            <tr>
              <td className="align-middle">2. DAPCC meeting</td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number" className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* Row 3 - Other Line Department Meetings */}
            <tr>
              <td className="align-top">
                3. Meetings with other line departments at district level for
                strengthening of program / implementation of innovative
                practices
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>

            {/* Row 4 - Other Meetings */}
            <tr>
              <td className="align-top">
                4. Other meetings (Specify) ______ DALSA
              </td>
              <td className="align-middle">
                <input type="date" className="text-center"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="number"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
              <td className="align-middle">
                <input type="text"  className="text-center" placeholder="Please Enter"/>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
